/**
 * Action types for workflow actions
 * Must match the ActionType enum in schema.prisma
 */
export var ActionType;
(function (ActionType) {
    ActionType["SMS"] = "SMS";
    ActionType["EMAIL"] = "EMAIL";
    ActionType["PHONE_CALL"] = "PHONE_CALL";
    ActionType["NOTIFICATION"] = "NOTIFICATION";
    ActionType["WEBHOOK"] = "WEBHOOK";
    ActionType["TASK_CREATION"] = "TASK_CREATION";
    ActionType["PUSH_INTEGRATION"] = "PUSH_INTEGRATION";
    ActionType["TRANSFER"] = "TRANSFER";
    ActionType["SHARE_CONVERSATION"] = "SHARE_CONVERSATION";
})(ActionType || (ActionType = {}));
//# sourceMappingURL=action-type.js.map